export default __webpack_public_path__ + "5ec62d9ee5b18c82cee37535ae4ab76d.png";